export enum ProductsActionType {
	FETCH_ALL_INSPIRATIONS_CATEGORY = 'FETCH_ALL_INSPIRATIONS_CATEGORY',
	STORE_ALL_INSPIRATIONS_CATEGORY = 'STORE_ALL_INSPIRATIONS_CATEGORY',
	ERROR_ALL_INSPIRATIONS_CATEGORY = 'ERROR_ALL_INSPIRATIONS_CATEGORY',

	ADD_CATEGORY_SUBCATEGORY = 'ADD_CATEGORY_SUBCATEGORY',
	UPDATE_CATEGORY_SUBCATEGORY = 'UPDATE_CATEGORY_SUBCATEGORY',
	STORE_CATEGORY_SUBCATEGORY = 'STORE_CATEGORY_SUBCATEGORY',
	DELETE_CATEGORY = 'DELETE_CATEGORY',
	DELETE_SUBCATEGORY = 'DELETE_SUBCATEGORY',

	FETCH_ALL_INSPIRATIONS_PRODUCTS = 'FETCH_ALL_INSPIRATIONS_PRODUCTS',
	STORE_ALL_INSPIRATIONS_PRODUCTS = 'STORE_ALL_INSPIRATIONS_PRODUCTS',
	ERROR_ALL_INSPIRATIONS_PRODUCTS = 'ERROR_ALL_INSPIRATIONS_PRODUCTS',

	FETCH_PRODUCT_DETAILS = 'FETCH_PRODUCT_DETAILS',
	STORE_PRODUCT_DETAILS = 'STORE_PRODUCT_DETAILS',
	ERROR_PRODUCT_DETAILS = 'ERROR_PRODUCT_DETAILS',
	FETCH_PRODUCT_ITEM_HISTORY = 'FETCH_PRODUCT_ITEM_HISTORY',
	STORE_PRODUCT_ITEM_HISTORY = 'STORE_PRODUCT_ITEM_HISTORY',
	ERROR_PRODUCT_ITEM_HISTORY = 'ERROR_PRODUCT_ITEM_HISTORY',
	DELETE_PRODUCT = 'DELETE_PRODUCT',

	UPDATE_PRODUCT_ITEM = 'UPDATE_PRODUCT_ITEM',
	BULK_EDIT_PRODUCTS = 'BULK_EDIT_PRODUCTS',
	UPLOAD_PRODUCT_IMAGE_FOR_BULK_EDIT = 'UPLOAD_PRODUCT_IMAGE_FOR_BULK_EDIT',
	UPDATE_PRODUCT_IMAGES = 'UPDATE_PRODUCT_IMAGES',
	DELETE_PRODUCT_IMAGE = 'DELETE_PRODUCT_IMAGE',

	FETCH_PRODUCT_CATEGORIES = 'FETCH_PRODUCT_CATEGORIES',
	STORE_PRODUCT_CATEGORIES = 'STORE_PRODUCT_CATEGORIES',
	FETCH_PRODUCT_SUB_CATEGORIES = 'FETCH_PRODUCT_SUB_CATEGORIES',
	STORE_PRODUCT_SUB_CATEGORIES = 'STORE_PRODUCT_SUB_CATEGORIES',

	FETCH_ALL_PRODUCTS_WARRANTY = 'FETCH_ALL_PRODUCTS_WARRANTY',
	STORE_ALL_PRODUCTS_WARRANTY = 'STORE_ALL_PRODUCTS_WARRANTY',
	ERROR_ALL_PRODUCTS_WARRANTY = 'ERROR_ALL_PRODUCTS_WARRANTY',
	ADD_WARRANTY = 'ADD_WARRANTY',
	UPDATE_WARRANTY = 'UPDATE_WARRANTY',
	DELETE_WARRANTY = 'DELETE_WARRANTY',
	BULK_EDIT_WARRANTY = 'BULK_EDIT_WARRANTY',
	UPDATE_PRODUCT_WARRANTY = 'UPDATE_PRODUCT_WARRANTY',

	FETCH_PRODUCT_ITEMS_DROPDOWN = 'FETCH_PRODUCT_ITEMS_DROPDOWN',
	STORE_PRODUCT_ITEMS_DROPDOWN = 'STORE_PRODUCT_ITEMS_DROPDOWN',
	ERROR_PRODUCT_ITEMS_DROPDOWN = 'ERROR_PRODUCT_ITEMS_DROPDOWN',

	ADD_PRODUCT_ITEM = 'ADD_PRODUCT_ITEM',
	UPDATE_COVER_IMAGE = 'UPDATE_COVER_IMAGE',

	FETCH_PRODUCT_AREA_LIST_DROPDOWN = 'FETCH_PRODUCT_AREA_LIST_DROPDOWN',
	STORE_PRODUCT_AREA_LIST_DROPDOWN = 'STORE_PRODUCT_AREA_LIST_DROPDOWN',
	ERROR_PRODUCT_AREA_LIST_DROPDOWN = 'ERROR_PRODUCT_AREA_LIST_DROPDOWN',

	FETCH_PRODUCT_ITEMS_DROPDOWN_V2 = 'FETCH_PRODUCT_ITEMS_DROPDOWN_V2',

	///
	FETCH_QUOTATION_AREA_LIST_DROPDOWN = 'FETCH_QUOTATION_AREA_LIST_DROPDOWN',
	STORE_QUOTATION_AREA_LIST_DROPDOWN = 'STORE_QUOTATION_AREA_LIST_DROPDOWN',
	ERROR_QUOTATION_AREA_LIST_DROPDOWN = 'ERROR_QUOTATION_AREA_LIST_DROPDOWN',

	FETCH_WARRANTY_DETAILS_BY_CODES = 'FETCH_WARRANTY_DETAILS_BY_CODES',
	STORE_WARRANTY_DETAILS_BY_CODES = 'STORE_WARRANTY_DETAILS_BY_CODES',
	ERROR_WARRANTY_DETAILS_BY_CODES = 'ERROR_WARRANTY_DETAILS_BY_CODES',

	FETCH_INTERNAL_CATEGORIES = 'FETCH_INTERNAL_CATEGORIES',
	STORE_INTERNAL_CATEGORIES = 'STORE_INTERNAL_CATEGORIES',
	ERROR_INTERNAL_CATEGORIES = 'ERROR_INTERNAL_CATEGORIES',

	FETCH_PRODUCT_TAXONOMY = 'FETCH_PRODUCT_TAXONOMY',
	STORE_PRODUCT_TAXONOMY = 'STORE_PRODUCT_TAXONOMY',
	ERROR_PRODUCT_TAXONOMY = 'ERROR_PRODUCT_TAXONOMY',
	ADD_XOR_GROUP = 'ADD_XOR_GROUP',
	UPDATE_XOR_GROUP = 'UPDATE_XOR_GROUP',
	DELETE_XOR_GROUP = 'DELETE_XOR_GROUP',
	ADD_PRODUCT_GROUP = 'ADD_PRODUCT_GROUP',
	UPDATE_PRODUCT_GROUP = 'UPDATE_PRODUCT_GROUP',
	DELETE_PRODUCT_GROUP = 'DELETE_PRODUCT_GROUP',

	UPLOAD_PRODUCT_3D_MODEL = 'UPLOAD_PRODUCT_3D_MODEL',
	REMOVE_PRODUCT_3D_MODEL = 'REMOVE_PRODUCT_3D_MODEL',

	FETCH_DEFAULT_MODELS = 'FETCH_DEFAULT_MODELS',
	STORE_DEFAULT_MODELS = 'STORE_DEFAULT_MODELS',
	UPLOAD_SUBCATEGORY_DEFAULT_MODEL = 'UPLOAD_SUBCATEGORY_DEFAULT_MODEL',
	REMOVE_SUBCATEGORY_DEFAULT_MODEL = 'REMOVE_SUBCATEGORY_DEFAULT_MODEL'
}
